export default __webpack_public_path__ + "static/media/ic_telegram-1.9c02b954.svg";